/* =============================================
   ANBE Madrid - Límite de unidades por talla
   Máximo MAX unidades de cada variante (talla) en la cesta.
   Actúa sobre todas las llamadas del tema al carrito
   (añadir desde ficha, drawer de tallas, "Combínalo con",
   botones +/− del carrito y página de carrito).
   ============================================= */
(function () {
  'use strict';
  if (window.__anbeQtyLimit) return;
  window.__anbeQtyLimit = true;

  const MAX = 2;
  const MSG = 'Puedes añadir como máximo ' + MAX + ' unidades por talla.';
  const nativeFetch = window.fetch.bind(window);
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function kind(url) {
    let path = '';
    try { path = new URL(url, location.origin).pathname; } catch (e) { return null; }
    if (/\/cart\/add(\.js)?$/.test(path)) return 'add';
    if (/\/cart\/change(\.js)?$/.test(path)) return 'change';
    if (/\/cart\/update(\.js)?$/.test(path)) return 'update';
    return null;
  }

  function getCart() {
    return nativeFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
  }

  function qtyInCart(cart, variantId) {
    return cart.items
      .filter(i => String(i.variant_id) === String(variantId))
      .reduce((s, i) => s + i.quantity, 0);
  }

  function limitResponse() {
    toast(MSG);
    return new Response(JSON.stringify({ status: 422, message: 'Cantidad máxima', description: MSG }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  let toastTimer = null;
  function toast(text) {
    let el = document.getElementById('anbe-qty-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'anbe-qty-toast';
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
        'background:#1a1a18;color:#fff;padding:12px 18px;font-family:Jost,sans-serif;font-size:12px;' +
        'letter-spacing:1px;max-width:90vw;text-align:center;opacity:0;transition:opacity .2s ease;pointer-events:none;';
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.style.opacity = '1';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.style.opacity = '0'; }, 3500);
  }

  // ---- Leer y reescribir el cuerpo de la petición ----
  function readBody(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      try { return { type: 'json', data: JSON.parse(body) }; } catch (e) {}
      return { type: 'params', data: new URLSearchParams(body) };
    }
    if (body instanceof FormData) return { type: 'form', data: body };
    if (body instanceof URLSearchParams) return { type: 'params', data: body };
    return null;
  }

  function writeBody(parsed) {
    if (parsed.type === 'json') return JSON.stringify(parsed.data);
    if (parsed.type === 'params') return parsed.data.toString();
    return parsed.data; // FormData
  }

  // Devuelve lista de {id, quantity, set(q)} para /cart/add
  function addLines(parsed) {
    const d = parsed.data;
    if (parsed.type === 'json') {
      if (Array.isArray(d.items)) {
        return d.items.map(it => ({ id: it.id, quantity: Number(it.quantity || 1), set: q => { it.quantity = q; } }));
      }
      if (d.id) return [{ id: d.id, quantity: Number(d.quantity || 1), set: q => { d.quantity = q; } }];
      return [];
    }
    const id = d.get('id');
    if (!id) return [];
    return [{ id, quantity: Number(d.get('quantity') || 1), set: q => d.set('quantity', String(q)) }];
  }

  async function handleAdd(input, init, parsed) {
    const lines = addLines(parsed);
    if (!lines.length) return nativeFetch(input, init);
    const cart = await getCart();
    const kept = [];
    let clamped = false;
    for (const l of lines) {
      const room = MAX - qtyInCart(cart, l.id);
      if (room <= 0) { clamped = true; continue; }
      if (l.quantity > room) { l.set(room); clamped = true; }
      kept.push(l);
    }
    if (!kept.length) return limitResponse();
    if (parsed.type === 'json' && Array.isArray(parsed.data.items)) {
      parsed.data.items = parsed.data.items.filter(it => kept.some(k => String(k.id) === String(it.id)));
    }
    if (clamped) toast(MSG);
    return nativeFetch(input, Object.assign({}, init, { body: writeBody(parsed) }));
  }

  async function handleChange(input, init, parsed) {
    const d = parsed.data;
    const get = k => (parsed.type === 'json' ? d[k] : d.get(k));
    const set = (k, v) => (parsed.type === 'json' ? (d[k] = v) : d.set(k, String(v)));
    const q = Number(get('quantity'));
    if (!(q > 0)) return nativeFetch(input, init);
    // Cantidad que tendrían OTRAS líneas de la misma talla
    const cart = await getCart();
    let item = null;
    if (get('line')) item = cart.items[Number(get('line')) - 1];
    else if (get('id')) item = cart.items.find(i => String(i.key) === String(get('id')) || String(i.variant_id) === String(get('id')));
    if (!item) return nativeFetch(input, init);
    const others = qtyInCart(cart, item.variant_id) - item.quantity;
    const allowed = Math.max(0, MAX - others);
    if (q > allowed) {
      set('quantity', allowed);
      toast(MSG);
    }
    return nativeFetch(input, Object.assign({}, init, { body: writeBody(parsed) }));
  }

  async function handleUpdate(input, init, parsed) {
    if (parsed.type !== 'json' || !parsed.data.updates) return nativeFetch(input, init);
    const u = parsed.data.updates;
    if (Array.isArray(u)) return nativeFetch(input, init);
    let clamped = false;
    Object.keys(u).forEach(k => {
      if (Number(u[k]) > MAX) { u[k] = MAX; clamped = true; }
    });
    if (clamped) toast(MSG);
    return nativeFetch(input, Object.assign({}, init, { body: writeBody(parsed) }));
  }

  window.fetch = function (input, init) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      const k = method === 'POST' ? kind(url) : null;
      if (!k || !init || !init.body) return nativeFetch(input, init);
      const parsed = readBody(init.body);
      if (!parsed) return nativeFetch(input, init);
      if (k === 'add') return handleAdd(input, init, parsed).catch(() => nativeFetch(input, init));
      if (k === 'change') return handleChange(input, init, parsed).catch(() => nativeFetch(input, init));
      if (k === 'update') return handleUpdate(input, init, parsed).catch(() => nativeFetch(input, init));
    } catch (e) {}
    return nativeFetch(input, init);
  };

  // Selectores de cantidad: máximo visual
  function capInputs() {
    document.querySelectorAll('input[name="updates[]"], input[name="quantity"], [data-minimog-cart-items] input[type="number"]').forEach(inp => {
      if (inp.getAttribute('max') !== String(MAX)) inp.setAttribute('max', String(MAX));
    });
  }
  let capQueued = false;
  new MutationObserver(() => {
    if (capQueued) return;
    capQueued = true;
    requestAnimationFrame(() => { capQueued = false; capInputs(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') capInputs();
  else document.addEventListener('DOMContentLoaded', capInputs);
})();
